import React, { useEffect, useState, useContext } from 'react'
import axios from 'axios'
import validator from 'validator'

import AppContext from '../../../contexts/AppContext'
import Modal from '../../../components/Modal/Modal'
import FormErrors from '../../../components/FormErrors/FormErrors'
import Button from '../../../components/Button/Button'

export default function ({ isOpen, onClose }) {
  const { user, setUser } = useContext(AppContext)
  const [isModalOpen, setModalOpen] = useState(false)
  const [email, setEmail] = useState(user.email)
  const [errors, setErrors] = useState([])

  const onSubmit = async (event) => {
    event.preventDefault()
    setErrors([])
    let _errors = []

    if (!validator.isEmail(email)) return setErrors(['Email does not look correct.'])
    else if (email === user.email) return setErrors(['Email cannot be the same as your current.'])

    const data = {
      email,
      userId: user._id,
    }

    try {
      await axios.post('/api/user/change-email', data)
      onClose()

      setUser({
        ...user,
        email,
      })
    } catch (e) {
      setErrors([e.response.data.message])
    }
  }

  const closeModal = () => {
    onClose()
  }

  useEffect(() => {
    setModalOpen(isOpen)
  }, [isOpen])

  return (
    <Modal isOpen={isModalOpen} onClose={closeModal} title="Change email">
      <form className="form" onSubmit={onSubmit}>
        {!!errors.length && <FormErrors errors={errors} />}
        <div className="form__group">
          <label className="form__label">New email</label>
          <input className="form__input" placeholder={email} onChange={(e) => setEmail(e.target.value)} />

          <Button type="submit">Change</Button>
        </div>
      </form>
    </Modal>
  )
}
